import React, {useEffect, lazy, Suspense } from 'react';
import store from './redux/store'
import {connect} from 'react-redux'
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import PropTypes from 'prop-types'
import Register from './components/acounts/Register'
import Login from './components/acounts/Login'
import ShowLogicTree from './components/showLogicTree/ShowLogicTree'
import ChoseOption from './components/ChoseOption'
import {
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import {setPickedTreeId, loadUser, addOptionQueryParam, setChosenOptionCategory} from './redux/actions'
import MyNavbar from './components/MyNavbar'
import HomeScreenV2 from './components/homeScreen/HomeScreenV2'
import PathRederict from './components/PathRederict'
import {FadingRoute} from './components/router/RoteAnimations'

const Userpage = lazy(() => import('./components/Userpage'));
const AboutScreen = lazy(() => import ('./components/aboutScreen/AboutScreen'))
const OptionsCompare = lazy(() => import ('./components/options/OptionsCompare'))
const Contact = lazy(() => import ('./components/contact/Contact'))

function App(props){
  const LOAD_USER_PROCESS_ID = "LOAD_USER_PROCESS_ID";

   useEffect(() => {
     try {
       props.loadUser(LOAD_USER_PROCESS_ID);
     } catch (e) {
       console.log("got error in init");
       console.log(e);
     } finally {
     }
   }, [])

   return (
     <div className="App">
       <MyNavbar/>
       <Switch>
         <Suspense fallback={<div>Loading...</div>}>
         {/*<Route path="/build_util_function"> <BuildUtilityFunction/> </Route>*/}
         <FadingRoute path="/about" component={AboutScreen}/>
         <Route path="/userpage"> <Userpage/> </Route>
         <Route path="/logic_tree"> <ShowLogicTree/> </Route>
         <Route path="/register"> <Register/>   </Route>
         <Route path="/login"> <Login/> </Route>
         <Route path="/contact"> <Contact/> </Route>
         <Route path="/choose"> <ChoseOption/> </Route>
         <Route exact path="/home">
         <Redirect to={"/choose?category=phones&treeId=1&ordering=-score"}/>
             {/* <HomeScreenV2/> */}

        </Route>
         <Route exact path="/">
            <Redirect to={"/choose?category=phones&treeId=1&ordering=-score"}/>
            {/* <HomeScreenV2/> */}
          </Route>
        </Suspense>
       </Switch>
     </div>)
   }

const mapStateToProps = (state) => ({
  queryParams: state.optionQueryParams,
})

const actionsCreators = {
  loadUser: loadUser,
  addOptionQueryParam:addOptionQueryParam,
  setChosenOptionCategory:setChosenOptionCategory,
  setPickedTreeId:setPickedTreeId,
}

export default connect(mapStateToProps, actionsCreators)(App)
